import { useState } from "react";
import { putReceipt } from "../../../services/Rest.jsx";
import Button from "../button/Button";
import IntInput from "../input/IntInput.jsx";

const FormReceiptPrecintas = ({ onClose, refetch, receipt }) => {
  const [error, setError] = useState("");

  const initialState = {
    precintas: "",
  };

  const [formData, setFormData] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleReset = () => {
    setFormData(initialState);
  };

  const handlePutPrecintas = async (e) => {
    e.preventDefault();
    try {
      await putReceipt(receipt.id, formData, receipt.etag);
      onClose();
      await refetch();
    } catch (e) {
      console.log(e.message);
      setError(e.response.data.detail);
    }
  };

  return (
    <form id="login-form" className="space-y-4" onSubmit={handlePutPrecintas} onReset={handleReset}>
      {error && <p className="text-red-500 text-sm">{error}</p>}
      <div className="space-y-4">
        <IntInput
          id="precintas"
          text="Precintas"
          placeholder="ej. 14, 33"
          onChange={handleChange}
          value={formData.precintas}
        />
      </div>
      <div className="space-y-2">
        <Button
          className="w-full bg-blue-700 text-white text-xs hover:bg-blue-900 font-bold py-1 px-3 rounded-md shadow-sm transition-colors"
          type="submit"
          onClick={handlePutPrecintas}
        >
          SAVE
        </Button>
      </div>
    </form>
  );
};

export default FormReceiptPrecintas;
